<template>
  <v-layout>
    <v-flex xs12>
      <v-card class="elevation-2 mx-2 my-1 pa-1">
        <v-container>
          <v-layout row wrap>
            <v-switch
              dense
              hide-details
              color="primary"
              class="px-2 mt-0"
              v-for="item in productTypes"
              :key="item.productTypeId"
              :label="item.type"
              value
              :input-value="item.value"
              @change="(value) => selectTypes(item.productTypeId, value)"
            ></v-switch>
            <v-spacer></v-spacer>
            <v-switch
              dense
              hide-details
              color="secondary"
              class="px-2 mt-0"
              label="Хол. зона"
              v-model="isColdZone"
            ></v-switch>
            <v-switch
              dense
              hide-details
              color="secondary"
              class="px-2 mt-0"
              label="Препараты РБ"
              v-model="isCountryBelarus"
            ></v-switch>
            <!-- <v-switch
              color="primary"
              label="Не задано"
              @change="value => selectTypes(0, value)"
            ></v-switch> -->
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    types: Array,
  },
  data: () => ({}),
  mounted() {},
  computed: {
    productTypes() {
      return this.types.map((item) => {
        item.value = false;
        return item;
      });
    },
    isColdZone: {
      get() {
        return this.$store.state.products.selectedColdZone;
      },
      set(value) {
        this.$store.dispatch("products/UPDATE_SELECTED_COLD_ZONE", value, {
          root: true,
        });
      },
    },
    isCountryBelarus: {
      get() {
        return this.$store.state.products.selectedCountryBelarus;
      },
      set(value) {
        this.$store.dispatch(
          "products/UPDATE_SELECTED_COUNTRY_BELARUS",
          value,
          {
            root: true,
          }
        );
      },
    },
  },
  methods: {
    ...mapActions({
      updateSelectedProductTypes: "products/UPDATE_SELECTED_PRODUCT_TYPES",
    }),
    selectTypes(productTypeId, value) {
      this.updateSelectedProductTypes({ productTypeId, value });
    },
  },
};
</script>
